module.exports = __webpack_public_path__ + "0a0a40409e990b389ce18b434c242a09.svg";